import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  ADD_WORK,
  DELETE_WORK,
  EDIT_WORK,
  GET_ALL_PAGE_WORKS,
  GET_WORK,
} from "./actionTypes";
import {
  getAllPageSectionsApi as getAllPageWorksApi,
  getSectionApi as getWorkApi,
  editSectionApi as editWorkApi,
  addSectionApi as addWorkApi,
  deleteSectionApi as deleteWorkApi,
} from "api/section";

import {
  deleteWorkFailure,
  deleteWorkSuccess,
  editWorkFailure,
  editWorkSuccess,
  addWorkFailure,
  addWorkSuccess,
  getWorkFailure,
  getWorkSuccess,
  getAllPageWorksFailure,
  getAllPageWorksSuccess,
} from "./actions";
import { toastErrorMessageNew } from "helpers/toaster/toastErrorMessageNew";

function* getAllPageWorks({ payload }) {
  try {
    const { data } = yield call(getAllPageWorksApi, payload);
    yield put(getAllPageWorksSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });
    yield put(getAllPageWorksFailure(error.response.data || error));
  }
}

function* getWork({ payload }) {
  try {
    const { data } = yield call(getWorkApi, payload);
    yield put(getWorkSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });
    yield put(getWorkFailure(error.response.data || error));
  }
}

function* addWork({ payload }) {
  try {
    const { data  , success} = yield call(addWorkApi, {
      data: payload.data,
      page: payload.page,
    });

    if (success) {
    yield put(addWorkSuccess(data));
    payload.toast.success("تم اضافة المشروع بنجاح");
    payload.navigate(`/${payload.page}`);

    }
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });
    yield put(addWorkFailure(error.response.data || error));
  }
}

function* editWork({ payload }) {
  try {
    const { data , success } = yield call(editWorkApi, {
      data: payload.data,
      slug: payload.slug,
      page: payload.page,

    });

    if (success) {
    const workAfterEdit = data.sections.find(
      (section) => section.slug === payload.slug
    );

    payload.toast.success("تم تحديث المشروع بنجاح");

    if (payload?.navigate) {
      payload.navigate(`/${payload.page}`);
    }
    yield put(editWorkSuccess(workAfterEdit));
  }
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });
    yield put(editWorkFailure(error.response.data || error));
  }
}

function* deleteWork({ payload }) {
  try {
    yield call(deleteWorkApi, {
      slug: payload.slug,
      page: payload.page,
    });
    yield put(deleteWorkSuccess(payload));
    payload.toast.success("تم الحذف بنجاح");
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });
    yield put(deleteWorkFailure(error.response.data || error));
  }
}

export function* watchGetWork() {
  yield takeEvery(GET_WORK, getWork);
}

export function* watchAddWork() {
  yield takeEvery(ADD_WORK, addWork);
}

export function* watchEditWork() {
  yield takeEvery(EDIT_WORK, editWork);
}

export function* watchDeleteWork() {
  yield takeEvery(DELETE_WORK, deleteWork);
}

export function* watchGetAllPageWorks() {
  yield takeEvery(GET_ALL_PAGE_WORKS, getAllPageWorks);
}

function* workSaga() {
  yield all([
    fork(watchGetWork),
    fork(watchEditWork),
    fork(watchGetAllPageWorks),
    fork(watchAddWork),
    fork(watchDeleteWork),
  ]);
}

export default workSaga;
